// Generated by CoffeeScript 1.12.7
var CouldNotLoad, findModule, makePath, resolveAsNode, tryFind;

makePath = require('./make-path');

CouldNotLoad = require('./could-not-load');

findModule = function(base, fileName, callers) {
  var e, fullPath;
  fullPath = makePath(base, fileName, callers);
  try {
    return {
      instance: require(fullPath),
      path: fullPath
    };
  } catch (error) {
    e = error;
    if (callers.length > 0) {
      return findModule(base, fileName, callers.slice(0, -1));
    } else {
      throw e;
    }
  }
};

tryFind = function(base, fileName, callers) {
  var e, e2;
  try {
    return {
      instance: require(fileName),
      path: fileName
    };
  } catch (error) {
    e = error;
    if (e.code === 'MODULE_NOT_FOUND') {
      try {
        return findModule(base, fileName, callers);
      } catch (error) {
        e2 = error;
        throw new CouldNotLoad(base, fileName, callers, e);
      }
    } else {
      return {
        instance: {},
        path: makePath(base, fileName, callers)
      };
    }
  }
};

resolveAsNode = function(base, fileName, callers) {
  var fullPath, paths;
  paths = callers.map(function(item) {
    return base + "/node_modules/" + item;
  });
  paths.push(base);
  fullPath = require.resolve(fileName, {
    paths: paths
  });
  return fullPath.replace(/\.js$/, '');
};

exports.instance = function(base, fileName, callers) {
  if (typeof window === 'undefined') {
    return require(resolveAsNode(base, fileName, callers));
  }
  return tryFind(base, fileName, callers).instance;
};

exports.path = function(base, fileName, callers) {
  if (typeof window === 'undefined') {
    return resolveAsNode(base, fileName, callers);
  }
  return tryFind(base, fileName, callers).path;
};
